import React, { useState } from 'react';
import {
  Grid,
  Button,
  OutlinedInput,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';

const Blockform = ({ item, blocks, setBlocks }) => {

  const [block, setBlock] = useState(item);

  const updateBlocks = (newBlock) => {
    setBlocks(prevBlocks => {
      // Check if block already exists
      const existingBlockIndex = prevBlocks.findIndex(
        block => block.order === newBlock.order
      );

      if (existingBlockIndex !== -1) {
        // Update existing block
        return prevBlocks.map((block, index) =>
          index === existingBlockIndex
            ? { ...block, ...newBlock }
            : block
        );
      }

      // Add new block to array
      return [...prevBlocks, newBlock];
    });
  };

  console.log('form blocks', blocks)



  return (
    <Grid item xs={12} sm={12} md={8}>
      <form id={`updateForm-${item.order}`} className="cell" encType="multipart/form-data">

        <input type="text" name="order" id="order" className="is-hidden" defaultValue={item.order} />

        <FormControl fullWidth margin="normal">
          <InputLabel htmlFor="name">Block Name</InputLabel>
          <OutlinedInput
            id="name"
            name="name"
            label="Project Name"
            onChange={(e) => setBlock({ ...block, name: e.target.value })}
            value={block.name}
          />
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel htmlFor="image">Image URL</InputLabel>
          <OutlinedInput
            id="image"
            name="image"
            label="Block image"
            onChange={(e) => setBlock({ ...block, image: e.target.value })}
            value={block.image}
          />
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel htmlFor="image">URL</InputLabel>
          <OutlinedInput
            id="url"
            name="url"
            label="Block URL"
            onChange={(e) => setBlock({ ...block, url: e.target.value })}
            value={block.url}
          />
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel htmlFor="image">Description</InputLabel>
          <OutlinedInput
            id="description"
            name="description"
            label="Block URL"
            onChange={(e) => setBlock({ ...block, description: e.target.value })}
            value={block.description}
          />
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel id="projectTypeLabel">Project Type</InputLabel>
          <Select
            labelId="type"
            id="type"
            value={block.type}
            label="Project Type"
            onChange={(e) => setBlock({ ...block, type: e.target.value })}
          >
            <MenuItem value="Residential">Residential</MenuItem>
            <MenuItem value="Motor Retail">Motor Retail</MenuItem>
            <MenuItem value="Commercial">Commercial</MenuItem>
            <MenuItem value="Refurbishment and Extensions">Refurbishment and Extensions</MenuItem>
            <MenuItem value="Public Sector">Public Sector</MenuItem>
            <MenuItem value="Leisure">Leisure</MenuItem>
            <MenuItem value="Student Living">Student Living</MenuItem>
          </Select>
        </FormControl>
      </form>
      <Grid>
        <Button fontSize="small"
          onClick={() => updateBlocks(block)}
          style={{ flex: 1 }}
          color="primary"
          aria-label="Menu">
            Update block
        </Button>
      </Grid>
    </Grid>
  )
};

export default Blockform;
